import React from 'react';
import { Link } from 'react-router-dom';
import { resolveProductMediaUrl } from '../../services/apiService';
import { formatPrice } from '../../utils/currency';
import { getPartDetailPath } from '../../utils/partDetailRoutes';
import { useThemeClasses } from '../../hooks/useThemeClasses';

const PLACEHOLDER =
  "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Crect width='120' height='120' fill='%23f3f4f6'/%3E%3Crect x='8' y='8' width='104' height='104' rx='8' fill='%23e5e7eb'/%3E%3Cg fill='%239ca3af'%3E%3Ccircle cx='44' cy='40' r='9'/%3E%3Cpath d='M20 68l19-19 12 12 17-17 32 24z'/%3E%3C/g%3E%3C/svg%3E";

export default function CrossSellSection({ items = [], title = 'Similar products' }) {
  const { isDark, sc } = useThemeClasses();

  if (!items.length) return null;

  return (
    <section className={sc('pdpPanel')}>
      <div className="mb-4 flex items-end justify-between gap-3">
        <h3 className={`text-base font-semibold ${isDark ? 'text-slate-200' : 'text-slate-900'}`}>
          {title}
        </h3>
        <p className={`hidden text-xs sm:block ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>
          Swipe to see more →
        </p>
      </div>
      <div
        className="
          flex gap-3 sm:gap-4 overflow-x-auto overscroll-x-contain pb-1 -mx-1 px-1
          snap-x snap-mandatory scroll-smooth
          [scrollbar-width:thin] [&::-webkit-scrollbar]:h-1.5
          [&::-webkit-scrollbar-thumb]:rounded-full
          [&::-webkit-scrollbar-thumb]:bg-slate-300
          dark:[&::-webkit-scrollbar-thumb]:bg-slate-600
        "
      >
        {items.map((item) => {
          const img = resolveProductMediaUrl(item.imageUrl) || PLACEHOLDER;
          return (
            <Link
              key={item.listingId}
              to={getPartDetailPath(item)}
              className={`${sc('pdpMiniCard')} w-[9.25rem] shrink-0 snap-start sm:w-[11rem] md:w-[12.5rem] lg:w-[13.5rem]`}
            >
              <div className={sc('pdpMiniCardImage')}>
                <img
                  src={img}
                  alt={item.name}
                  className="max-h-full max-w-full object-contain p-2 transition group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = PLACEHOLDER;
                  }}
                />
              </div>
              <p
                className={`mt-2 line-clamp-2 text-xs font-medium sm:text-sm ${
                  isDark ? 'text-slate-200' : 'text-slate-800'
                }`}
              >
                {item.name}
              </p>
              <p
                className={`mt-1 text-sm font-bold ${
                  isDark ? 'text-amber-400' : 'text-amber-700'
                }`}
              >
                {formatPrice(item.price)}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
